import React, { Fragment } from "react";
import {
  makeStyles,
  Container,
  Typography,
  Box,
  Link,
} from "@material-ui/core";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "black",
    color: theme.palette.primary.main,
    height: "100%",
    maxWidth: "1800px",
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(8),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(6),
      height: "auto",
    },
    [theme.breakpoints.down(450)]: {
      marginTop: theme.spacing(6),
      height: "auto",
    },
  },
  mainCompanyWrapper: {
    width: "60%",
    textAlign: "center",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  heading: {
    color: theme.palette.primary.main,
    fontSize: "32px",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
    },
  },
  description: {
    color: theme.palette.primary.main,
    textAlign: "justify",
    fontSize: "18px",
    fontWeight: 300,
    [theme.breakpoints.down("xs")]: {
      fontSize: "15px",
    },
  },
  specialDescription: {
    backgroundColor: theme.palette.primary.main,
    color: "black",
    textAlign: "justify",
    fontSize: "13px",
    fontWeight: 400,
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(8),
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  footer: {
    marginTop: "auto",
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  footerLink: {
    margin: "0 10px",
    color: theme.palette.primary.main,
    textDecoration: "none",
  },
}));

function Sell() {
  const classes = useStyles();

  return (
    <Container className={classes.root}>
      <Container className={classes.mainCompanyWrapper}>
        <Typography variant="p" className={classes.heading} align="center">
          Sell Through d2p: Empowering Authors and Publishers to Thrive
        </Typography>
        <Box marginTop={4}>
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            At d2p, we believe in giving authors and publishers the tools to
            take control of their literary success. Our platform allows you to
            create customized pages to showcase and sell your work in a
            professional, engaging, and user-friendly environment. Best of all,
            d2p is completely free to use—no hidden fees or charges to list your
            work
          </Typography>
          <br />
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            <b>Why Choose d2p?</b>
          </Typography>

          <br />

          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            d2p isn’t just another sales platform—we’re your dedicated partner
            in publishing success. Here’s why authors and publishers choose us:
          </Typography>

          <ul style={{ listStyle: "disc", marginLeft: 20 }}>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                Digital-First Platform: Sell your eBooks directly to readers,
                eliminating the hassle of delayed or damaged shipments. By
                reducing returns and opting for digital downloads, you’re not
                only streamlining the sales process but also helping the planet
                by cutting down on paper usage and carbon emissions.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                Low Commission Fees: We believe you deserve more. We take a
                minimal commission of 8% on eBook sales, with an even lower rate
                of just 6% if you join our KleverBook™ program.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                No Add-Ons to Your Transaction Fee: It’s common practice for
                companies to add an additional .5–1% fee on top of Stripe’s
                standard 2.9% + $0.30 transaction fee. Not us. With d2p, your
                transaction fee will always be just 2.9% + $0.30—no hidden fees,
                no surprises.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                Completely Free to Use: Unlike many platforms that charge fees
                for listing your work or add unexpected costs, d2p is completely
                free to use. There are no upfront charges to get started, so you
                can focus on your writing and sales without any financial
                barriers
              </Typography>
            </li>

            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                Exponential Exposure Through C5M’s Ecosystem: By listing your
                books on d2p, you gain access to C5M's interconnected platforms,
                amplifying your exposure across diverse markets and industries.
                Through divisions like eksplode! Interactive, GreenGenie,
                Gallery Aurora and others, your work can reach new audiences,
                giving you a competitive edge and exponential growth potential
                in the digital world. The power of C5M’s ecosystem means more
                opportunities for visibility, promotion, and revenue.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                Compare and Save: We offer the lowest fees in the industry,
                based on comprehensive research of leading platforms. At just 8%
                (or 6% with KleverBook™), you keep more of your earnings. Let’s
                stack up the numbers to show how much you keep with d2p:
                <ul style={{ listStyle: "disc",  marginLeft: 20 }}>
                  <li>
                    <Typography
                      variant="body1"
                      className={classes.description}
                      align="center"
                    >
                      Amazon (KDP): Takes up to 65% in royalties on books priced
                      below $2.99 or above $9.99. Additionally, self-published
                      authors lose up to 40% of their earnings through
                      distribution fees. Amazon's fees can vary depending on the
                      book's price and distribution channels.
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      variant="body1"
                      className={classes.description}
                      align="center"
                    >
                      Draft2Digital: Retains 40% of digital sales, leaving
                      authors with 60% of the revenue. While their distribution
                      network is broad, the commission is higher compared to
                      d2p’s more author-friendly structure.
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      variant="body1"
                      className={classes.description}
                      align="center"
                    >
                      Smashwords: Takes 15-30% in commission, depending on the
                      distribution channels and whether the book is available
                      for sale through their partner network. The more
                      distribution partners you choose, the higher the
                      commission.
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      variant="body1"
                      className={classes.description}
                      align="center"
                    >
                      XinXii: Retains up to 40% for books priced under $3.30,
                      which is relatively high compared to d2p. For
                      higher-priced books, their fee structure can become more
                      competitive, but still requires authors to share a
                      significant portion of their earnings.
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      variant="body1"
                      className={classes.description}
                      align="center"
                    >
                      Barnes & Noble Press: Retains up to 40% on eBook sales
                      priced below $2.99 and takes 30% on books priced above
                      $2.99. They offer a more competitive royalty structure for
                      higher-priced books, but the lower royalties on
                      lower-priced books can be a disadvantage for many authors.
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      variant="body1"
                      className={classes.description}
                      align="center"
                    >
                      Kobo Writing Life: Retains 30% commission on eBook sales,
                      offering authors a better royalty rate on books priced
                      above $2.99. However, for books priced lower, the
                      commission is higher, and the global reach is more limited
                      compared to Amazon and d2p.
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      variant="body1"
                      className={classes.description}
                      align="center"
                    >
                      Apple Books: Takes a flat 30% commission across all book
                      prices, with no additional fees. Apple’s royalty structure
                      is simple, but authors are often faced with a smaller
                      audience and fewer promotional tools compared to larger
                      platforms like Amazon.
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      variant="body1"
                      className={classes.description}
                      align="center"
                    >
                      Google Play Books: Retains 30% on eBook sales and offers a
                      pay-per- download model. While they have a massive global
                      reach, Google Play’s revenue share can be less favorable
                      compared to d2p, especially when combined with their
                      account set-up complexities and lack of tailored support
                      for authors.
                    </Typography>
                  </li>
                  <li>
                    <Typography
                      variant="body1"
                      className={classes.description}
                      align="center"
                    >
                      Lulu: Charges 20-40% on eBook sales, depending on the type
                      of distribution. Lulu is a print-on-demand platform that
                      also offers eBook distribution, but authors may find their
                      commission rates are higher than d2p’s, especially when
                      you factor in the printing costs for physical copies.
                    </Typography>
                  </li>
                </ul>
              </Typography>
            </li>
          </ul>

          <br />
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            <b>Why d2p is the Best Choice:</b>
          </Typography>

          <br />

          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            With d2p, you get the best of both worlds: the lowest commission
            rates and a digital-first model that eliminates the high costs of
            shipping and printing. We take a minimal commission—8% standard, and
            even lower with our KleverBook™ program at just 6%—ensuring that
            more of your hard-earned revenue stays in your pocket.
          </Typography>

          <br />
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            <b>The d2p Advantage:</b>
          </Typography>

          <br />

          <ul style={{ listStyle: "disc", marginLeft: 20 }}>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                More Earnings, Less Hassle: Keep up to 94% of your revenue,
                compared to much lower rates on most other platforms.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                No Hidden Fees: What you see is what you get—no surprise
                charges. And with no fees to list your books, d2p makes it easy
                for you to start selling without any financial barriers.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                Global Reach: We provide global exposure, so your work can reach
                readers around the world with a streamlined digital process.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                Sustainability: By going digital, you reduce paper waste and
                carbon emissions—helping both the planet and your bottom line.
              </Typography>
            </li>
          </ul>
          <br />
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            <b>How It Works</b>
          </Typography>

          <br />
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            Getting started with d2p is simple:
          </Typography>

          <br />

          <ul style={{ listStyle: "disc", marginLeft: 20 }}>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                Sign Up and Create Your Page: Customize your page to highlight
                your books, author bio, and personal brand. Make it uniquely
                yours and stand out from the crowd.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                List Your eBooks: Upload your eBooks in digital format, set your
                prices, and get ready to start selling. It’s that easy.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                Start Selling: Once your books are live, we handle the
                transactions, downloads, and reporting, so you can focus on what
                you do best—writing and connecting with your readers.
              </Typography>
            </li>
          </ul>

          <br />
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            <b>Sustainability at d2p</b>
          </Typography>

          <br />
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            By choosing d2p, you’re not only making a smart financial
            decision—you’re also helping the environment. Our digital-first
            approach eliminates the need for paper production, packaging, and
            shipping, reducing your carbon footprint and contributing to a more
            sustainable future for publishing
          </Typography>

          <br />

          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            <b>
              Unlock the Full Potential of Your Publishing Journey with
              KleverBook™
            </b>
          </Typography>

          <br />
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            Join our <b>KleverBook™ program</b> today and enjoy exclusive
            benefits, such as:
          </Typography>

          <br />

          <ul style={{ listStyle: "disc", marginLeft: 20 }}>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                Reduced Commission Fees: Only 6% commission on each eBook sold.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                List Your eBooks: Upload your eBooks in digital format, set your
                prices, and get ready to start selling. It’s that easy.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                Revenue Boost: Take advantage of integrated unskippable
                30-second ads within your eBooks, providing additional income
                streams while offering readers a dynamic, engaging experience.
              </Typography>
            </li>
            <li>
              <Typography
                variant="body1"
                className={classes.description}
                align="center"
              >
                Global Reach: Sell your eBooks worldwide, expanding your
                audience beyond traditional markets.
              </Typography>
            </li>
          </ul>

          <br />
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            <b>Join d2p Today</b>
          </Typography>

          <br />
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            Ready to take the next step in your publishing journey? Join d2p
            today to sell smarter, keep more of your earnings, and reach a
            global audience. Even better, join our KleverBook™ program and earn
            50% of the ad revenue generated by your eBooks. Click the KleverBook
            tab above to learn more
          </Typography>

          <br />
          <Typography
            variant="body1"
            className={classes.description}
            align="center"
          >
            Let us help you unlock the full potential of your work. Start
            selling today with d2p— where authors and publishers succeed
            together.
          </Typography>

          <br />

          <Typography
            variant="body1"
            className={classes.specialDescription}
            align="center"
          >
            According to{" "}
            <Link
              href="http://www.mycompanyworks.com"
              target="_blank"
              style={{ color: "black", textDecoration: "underline" }}
            >
              mycompanyworks.com
            </Link>
            , Amazon charges a royalty fee of 65% for books that sell below
            $2.99 and above $9.99 for published authors. They keep 30% on books
            that sell between $2.99 and $9.90. For self-published authors,
            Amazon takes 40%. As for Kindle, publishers are paid either 35% or
            70% royalty for each book sold. KDP takes 40%, Draft2Digital takes
            40% of digital sales, Smashwords takes 15 to 30%, and XinXii takes
            30% of net sales for books over $3.30 and 40% for books sold less
            than that.
          </Typography>
        </Box>
      </Container>
      <Container className={classes.footer}>
        <NavLink to="/register/:role" className={classes.footerLink}>
          Join
        </NavLink>
        <NavLink to="/" className={classes.footerLink}>
          Home
        </NavLink>
      </Container>
    </Container>
  );
}

export default Sell;
